import { DatePickerBusinessDay } from "components/DatePickerBussinessDay";
import { AditamentoDiferenca } from "./aditamentoRevisionModal";
import { SpecialFieldRender } from "./specialFieldRender";
import moment from "moment";
import { NumberField, TextField } from "m2m.components";
import { formatFieldName } from "./listagemDiferencas";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

export const SmartFieldEditor: React.FC<{
    diferenca: AditamentoDiferenca;
    fieldType: string;
    isEditing: boolean;
    onValueChange: (value: string) => void;
    classes: any;
}> = ({ diferenca, fieldType, isEditing, onValueChange, classes }) => {
    const { newField, nomeCampo } = diferenca;

    if (!isEditing) {
        return (
            <SpecialFieldRender
                value={newField}
                fieldType={fieldType}
                isOldValue={false}
                classes={classes}
            />
        );
    }

    switch (fieldType) {
        case 'date':
        case 'array-date':
            const dateValue = newField && newField !== 'null' ? moment(newField) : null;
            return (
                <DatePickerBusinessDay
                    value={dateValue}
                    onChange={(value) => onValueChange(value ? value.format('YYYY-MM-DD HH:mm:ss') : 'null')}
                    label={formatFieldName(nomeCampo)}
                    validateBusinessDay={nomeCampo.toLowerCase().includes('vencimento')}
                    keyValue={diferenca.caminhoCompleto}
                />
            );

        case 'number':
        case 'array-number':
            const numericValue = newField && newField !== 'null' ? parseFloat(newField) : undefined;
            return (
                <NumberField
                    value={numericValue}
                    onChange={(value) => onValueChange(value !== undefined && value !== null ? value.toString() : 'null')}
                    label={formatFieldName(nomeCampo)}
                    numberType="eightDecimals"
                />
            );

        case 'percentage':
        case 'array-percentage':
            const percentValue = newField && newField !== 'null' ? parseFloat(newField) : undefined;
            return (
                <NumberField
                    value={percentValue}
                    onChange={(value) => onValueChange(value !== undefined && value !== null ? value.toString() : 'null')}
                    label={formatFieldName(nomeCampo)}
                    numberType="sixDecimals"
                    helperText="Valor em percentual"
                />
            );

        case 'enum':
            return (
                <FormControl fullWidth variant="outlined">
                    <InputLabel id={`${nomeCampo}-label`}>{formatFieldName(nomeCampo)}</InputLabel>
                    <Select
                        labelId={`${nomeCampo}-label`}
                        value={newField || ''}
                        onChange={(event) => onValueChange(event.target.value as string)}
                        label={formatFieldName(nomeCampo)}
                    >
                        {(diferenca.enumValues || []).map((value) => (
                            <MenuItem key={value} value={value}>
                                {value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );

        case 'guid':
        case 'complex-object':
        case 'array-item':
            return (
                <TextField
                    value={newField}
                    onChange={(value) => onValueChange(value)}
                    label={formatFieldName(nomeCampo)}
                    disabled
                    helperText="Campo complexo - edição limitada"
                />
            );

        default:
            return (
                <TextField
                    value={newField}
                    onChange={(value) => onValueChange(value)}
                    label={formatFieldName(nomeCampo)}
                />
            );
    }
};